import React from 'react';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import MessageCourier from '../../lib/MessageCourier';
import { Club } from '../../system/Club/Club';
import SystemClient from '../../system/SystemClient';
import ComboBoxSearch, { IComboBoxSearch } from '../Common/ComboBoxSearch';
import { IComboBoxOption } from '@fluentui/react';
import ComboBoxInput from '../../lib/FormValidator/Form/ComboBoxInput';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import useForceUpdate from '../../common/custom-hooks/useForceUpdate';
import { AppContext } from '../../AppInRouterContext';
interface IClubSelector {
  appContext: AppContext;
  onSelect: (entity: Club) => void;
  selected: string[];
  options?: IComboBoxOption[];
}

export const ClubSelector = (props: IClubSelector) => {
  const clubs = useAsyncDataCourier(
    () => props.appContext.system.getClubesForDropdown(),
    [],
    props.appContext.courier
  );
  const getFromKey = (key: string) => {
    if (clubs) {
      const entity = clubs.find((e) => e.getId() == key);
      if (entity) {
        return props.onSelect(entity);
      }
    }
  };
  const clubOptions = React.useMemo(() => {
    let ret: IComboBoxOption[] = [];
    if (clubs) {
      ret = clubs.map((entity: Club) => {
        return { key: entity.getId()!, text: String(entity.getNombre()!), data: entity };
      });
    }

    return ret;
  }, [clubs]);
  return (
    <ComboBoxSearch
      onSelectOption={(opt) => getFromKey(String(opt.key))}
      selected={props.selected}
      options={props.options ? props.options : clubOptions}
      comboProps={{ label: 'Club', options: clubOptions }}
    ></ComboBoxSearch>
  );
};

interface IClubSelectorInput {
  appContext: AppContext;
  input: CustomInputIfc;
  hideLabel?: boolean;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  providedList?: Club[];
  disabled?: boolean;
  onChangeExtended?: (entity: Club) => void;
  label?: string;
  clubs: Club[];
}

export const ClubSelectorInput = (props: IClubSelectorInput) => {
  const { t, i18n } = useTranslation();
  const [currentClub, setCurrentClub] = React.useState<Club | undefined>(undefined);
  const [clubOptions, setClubOptions] = React.useState<IComboBoxOption[]>([]);
  // const clubs = useAsyncDataCourier(
  //   () =>
  //     props.providedList && props.providedList.length > 0
  //       ? Promise.resolve(props.providedList)
  //       : props.appContext.system.getClubesForDropdown(),
  //   [],
  //   props.appContext.courier
  // );
  const mapClubOptions = (clubs: Club[]) => {
    const opciones = clubs.map((entity: Club) => {
      return { key: entity.getId()!, text: getLabelFromClub(entity), data: entity };
    });
    setClubOptions(opciones);
  };
  const selectDefaultClub = (id: string) => {
    setCurrentClub(props.clubs ? props.clubs.find((entity: Club) => entity.getId() === id) : undefined);
  };
  const forceUpdate = useForceUpdate();
  const getLabelFromClub = (entity: Club) => {
    const label = String(entity.getNombre()!);
    return label;
  };

  React.useEffect(() => {
    forceUpdate();
  }, [currentClub]);
  React.useEffect(() => {
    selectDefaultClub(props.input.getValue());
    mapClubOptions(props.clubs ? props.clubs : []);
  }, [props.clubs, currentClub]);
  const onChangeExtended = () => {
    const _entity = props.clubs?.find((e) => e.getId() === props.input.getValue());
    if (_entity && props.onChangeExtended) {
      props.onChangeExtended(_entity);
    }
  };

  return (
    <>
      {props.clubs && (
        <ComboBoxInput
          input={props.input}
          label={props.hideLabel ? '' : props.label ? t(props.label) : t('Sin descriptor')}
          onBlur={props.onBlurCustomInput}
          options={clubOptions ? clubOptions : []}
          onChangeExtended={onChangeExtended}
        />
      )}
    </>
  );
};
